import * as Actions from '../index';
import * as TYPES from '../actions';
import { classRegistration } from '../../../api/mutations'
import { API, graphqlOperation } from 'aws-amplify'
import { toast } from 'react-toastify'

export const saveClassReg = userSubmission => {
    return {
        type: TYPES.REGISTER_FOR_CLASS,
        data: userSubmission,
    };
};

export const dispatchClassReg = (userData, ReceiveClassName) => {
    // console.log('userData ', userData)
    return dispatch => {
        try {
            return API.graphql(graphqlOperation(classRegistration, { input: userData })).then((result) => {
                dispatch(Actions.saveClassReg(JSON.parse(result.data.classRegistration)))
                // toast.success('Please make payment');
                // toast.success('You have Registered Successfully for ' + ReceiveClassName);
                return result
            })
        } catch (err) {
            console.log("Error in dispatch is ", err);
        }
    }
}